<form (ngSubmit)="lagre()" [formGroup]="skjema" class="e2e-medlem-rediger">
  <inline-skjema>
    <inline-skjema-tittel>{{'Rediger medlem' | translate}}</inline-skjema-tittel>

    <medlem-informasjon [medlem]="medlem()"/>

    <inline-melding type="info">
      {{'Redigering av personopplysninger må gjøres av medlemmet selv. Hvis medlemmet skal endre noe, kan du sende hen'|translate}}
      <a href="https://support.styreplan.no/no/article/redigere-personopplysninger-e-post-telefon-navn-bilde-1u931y2/" target="_blank">{{'denne hjelpeartikkelen'|translate}}</a>.
    </inline-melding>

    <div class="roller">
      <span class="ramme-tittel">{{ 'Roller'|translate }}</span>

      @for(linje of skjema.controls.nyeMedlemsroller.controls; track linje.value.id){
        <div class="rolleperiode e2e-rolleperiode">
          <ng-container *ngTemplateOutlet="tittelPeriodeFragment; context: {tittel: linje.value.rolle!.tittel, startdato: linje.value.startdato, sluttdato: linje.value.sluttdato, harSluttdato: linje.value.harSluttdato}"/>
          <div class="handlinger">
            <button type="button" mat-button (click)="slettNyRolleperiode(linje)" color="primary">{{ "Angre registrering"|translate }}</button>
          </div>
        </div>
      }

      @for(linje of skjema.controls.aktiveMedlemsroller.controls; track linje.value.rolleperiode!.id){
        <div class="rolleperiode e2e-rolleperiode" [ngClass]="{'slettet':linje.value.slettet}">
          <ng-container *ngTemplateOutlet="tittelPeriodeFragment; context: {tittel: linje.value.rolleperiode!.tittel, startdato: linje.value.startdato, sluttdato: linje.value.sluttdato, harSluttdato: linje.value.harSluttdato}"/>
          @if(linje.value.avsluttet){
            <div class="status">{{'Rollen avsluttes'}}</div>
          } @else if (linje.value.slettet){
            <div class="status">{{'Rollen slettes'}}</div>
          } @else {
            <div class="handlinger">
              <button type="button" mat-button (click)="visAvsluttRolleperiodeDialog(linje)" color="primary" class="e2e-avslutt">{{ "Avslutt rolle"|translate }}</button>
              <ng-container *ngTemplateOutlet="eksisterendeRolleperiodeMeny; context: {linje: linje}"/>
            </div>
          }
        </div>
      }
      @if(skjema.controls.inaktiveMedlemsroller.value.length > 0 && !visInaktiveMedlemsroller){
        <a (click)="visInaktiveMedlemsroller = true">{{'Vis {antall} inaktive roller'|translate: {antall: skjema.controls.inaktiveMedlemsroller.value.length} }}</a>
      }
      @if(visInaktiveMedlemsroller){
        <a (click)="visInaktiveMedlemsroller = false">{{'Skjul {antall} inaktive roller'|translate: {antall: skjema.controls.inaktiveMedlemsroller.value.length} }}</a>

        @for(linje of skjema.controls.inaktiveMedlemsroller.controls; track linje.value.rolleperiode!.id){
          <div class="rolleperiode" [ngClass]="{'slettet':linje.value.slettet}">
            <ng-container *ngTemplateOutlet="tittelPeriodeFragment; context: {tittel: linje.value.rolleperiode!.tittel, startdato: linje.value.startdato, sluttdato: linje.value.sluttdato, harSluttdato: linje.value.harSluttdato}"/>
            @if (linje.value.slettet){
              <div class="status">{{'Rollen slettes'}}</div>
            } @else {
              <div class="handlinger">
                <ng-container *ngTemplateOutlet="eksisterendeRolleperiodeMeny; context: {linje: linje}"/>
              </div>
            }
          </div>
        }
      }
      <button mat-stroked-button type="button" color="primary" (click)="visNyRolleperiodeDialog()" data-testid="visNyRolleperiodeDialog">
        <i class="ion-ios-plus-empty md-button-liten"></i>
        {{ "Legg til ny rolle"|translate }}
      </button>

    </div>

    <medlem-rediger-tilgangsroller [formControl]="skjema.controls.tilgangsroller" />

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()"
              [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
        {{ "Lagre"|translate }}
      </button>
    </inline-skjema-handlinger>
  </inline-skjema>
</form>



<!--tittel og periode visning-->
<ng-template #tittelPeriodeFragment let-tittel="tittel" let-startdato="startdato" let-sluttdato="sluttdato" let-harSluttdato="harSluttdato">
  <div class="tittel-periode">
    <div class="tittel e2e-tittel">{{tittel}}</div>
    <div class="periode e2e-periode">
      {{startdato | plaindate}}
      {{'til'|translate}}
      @if(harSluttdato){
        {{sluttdato | plaindate}}
      } @else {
        {{'(slutt ikke angitt)'|translate}}
      }
    </div>
  </div>
</ng-template>

<!--handlinger-meny for eksisterende rolle-->
<ng-template #eksisterendeRolleperiodeMeny let-linje="linje">
  <button type="button" mat-icon-button [matMenuTriggerFor]="aktivRolleMeny" (click)="$event.stopPropagation()" aria-label="Rolleperiodemeny" class="mat-medium-icon-button e2e-meny">
    <mat-icon class="material-symbols-fet">more_vert</mat-icon>
  </button>
  <mat-menu #aktivRolleMeny="matMenu">
    <button mat-menu-item (click)="visRedigerRolleperiodeDialog(linje)">
      <mat-icon>edit</mat-icon>
      <span>{{ "Rediger datoer" | translate }}</span>
    </button>
    <button mat-menu-item (click)="visSlettAktivRolleperiodeDialog(linje)">
      <mat-icon>edit</mat-icon>
      <span>{{ "Angre registrering" | translate }}</span>
    </button>
  </mat-menu>
</ng-template>

<!--Skjemafragment for redigering av rolle-periode (start/slutt-dato)-->
<ng-template #rolleperiodeskjema let-skjema="skjema">
<div class="rolleperiode">
  <mat-form-field class="startdato">
    <mat-label>{{ "Rollens startdato"|translate }}</mat-label>
    <input matInput [matDatepicker]="startdatoVelger" [max]="skjema.value.sluttdato" [formControl]="skjema.controls.startdato" class="e2e-startdato" data-testid="rolle-startdato-felt" #startdatofelt>
    <mat-datepicker-toggle matPrefix [for]="startdatoVelger"/>
    <mat-datepicker #startdatoVelger/>
    @if(skjema.controls.startdato.hasError('matDatepickerParse')){
      <mat-error data-testid="matDatepickerParse">{{ skjema.controls.startdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
    }
    @if(skjema.controls.startdato.hasError('overlappendePeriodeIdentiskRolle')){
      <mat-error data-testid="overlappendePeriodeIdentiskRolle">
        {{ 'Overlapper med {rolle} ({periode})'|translate: {rolle:skjema.controls.startdato.getError('overlappendePeriodeIdentiskRolle').rolleTittel, periode: skjema.controls.startdato.getError('overlappendePeriodeIdentiskRolle').periode | datoperiodeutentid} }}
      </mat-error>
    }
  </mat-form-field>
  <div class="sluttdatovalg">
    @if(skjema.value.harSluttdato){
      <mat-form-field class="sluttdato">
        <mat-label>{{ "Rollens sluttdato"|translate }}</mat-label>
        <input matInput [matDatepicker]="sluttdatoVelger" [min]="skjema.value.startdato" [formControl]="skjema.controls.sluttdato" class="e2e-sluttdato" data-testid="rolle-sluttdato-felt" #sluttdatofelt>
        <mat-datepicker-toggle matPrefix [for]="sluttdatoVelger"/>
        <mat-datepicker #sluttdatoVelger/>
        @if(skjema.controls.sluttdato.hasError('matDatepickerParse')){
          <mat-error data-testid="matDatepickerParse">{{ skjema.controls.sluttdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
        }
        @if (skjema.controls.sluttdato.hasError('matDatepickerMin')) {
          <mat-error data-testid="matDatepickerMin">{{ 'Sluttdata kan ikke være tidligere enn startdato ({startdato})'|translate: {startdato: skjema.value.startdato|plaindate} }}</mat-error>
        }
      </mat-form-field>
    }
    <mat-slide-toggle [formControl]="skjema.controls.harSluttdato" class="har-sluttdato" data-testid="send-invitasjonsepost">
      {{'Rollen har en sluttdato'|translate}}
    </mat-slide-toggle>
  </div>
</div>
</ng-template>

<!--Skjema for registrering av ny rolleperiode-->
<ng-template #nyRolleperiodeTemplate>
  <div class="ny-rolleperiode-dialog e2e-ny-rolleperiode-dialog">
  <h2 mat-dialog-title>{{ "Legg til ny rolle"|translate }}</h2>
  <mat-dialog-content class="skjema">
    <form>
      <mat-form-field class="rolle">
        <mat-label>{{ 'Rolle'|translate }}</mat-label>
        <mat-select [formControl]="nyRolleSkjema.controls.rolle" [compareWith]="erValgtRolle" data-testid="rolle-felt" class="e2e-rolle">
          @for (rolle of tilgjengeligRoller; track rolle.id) {
            <mat-option [value]="rolle">{{ rolle.tittel }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <ng-container *ngTemplateOutlet="rolleperiodeskjema; context: {skjema: nyRolleSkjema}"/>
      @if(overlappendePeriode){
      <inline-melding type="advarsel">
        {{ 'Valgt periode overlapper med eksisterende periode for rollen {rolle}: {periode}'|translate: {rolle:overlappendePeriode.rolleTittel, periode: overlappendePeriode.periode | datoperiodeutentid} }}
      </inline-melding>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button (click)="avbrytAktivDialog()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" (click)="registrerNyRolleperiode()" [disabled]="nyRolleSkjema.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Legg til ny rolle"|translate }}</button>
  </mat-dialog-actions>
  </div>
</ng-template>

<!--Skjema for redigering av eksisterende rolleperiode -->
<ng-template #redigerRolleperiodeTemplate>
  <div class="oppdater-rolleperiode-dialog e2e-oppdater-rolleperiode-dialog">
    <h2 mat-dialog-title>{{ "Rediger datoer"|translate }}</h2>
    <mat-dialog-content class="skjema">
      <form>
        <p>
          {{'Velg tidsperiode for {medlem}s rolle'|translate:{medlem: medlem().navn, rolle: redigerRolleSkjema!.value.rolleperiode!.tittel} }}
          <span class="uthevet">{{redigerRolleSkjema!.value.rolleperiode!.tittel}}</span>
        </p>
        <ng-container *ngTemplateOutlet="rolleperiodeskjema; context: {skjema: redigerRolleSkjema}"/>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="avbrytAktivDialog()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" (click)="oppdaterRolleperiode()" [disabled]="redigerRolleSkjema!.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Oppdater datoer"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!--Skjema for å avslutte av eksisterende rolleperiode -->
<ng-template #avsluttRolleperiodeTemplate>
  <div class="avslutt-rolleperiode-dialog e2e-avslutt-rolleperiode-dialog">
    <h2 mat-dialog-title>{{ "Avslutt rolle"|translate }}</h2>
    @if(avsluttRolleperiodeTrinn == 'avslutt'){
      <mat-dialog-content class="skjema">
        <form>
          <p>
            {{'Sett sluttdato for {medlem}s rolle'|translate:{medlem: medlem().navn} }}
            <span class="uthevet">{{redigerRolleSkjema!.value.rolleperiode!.tittel}}</span>
          </p>
          <mat-form-field class="sluttdato">
            <mat-label>{{ "Rollens sluttdato"|translate }}</mat-label>
            <input matInput [matDatepicker]="sluttdatoVelger" [min]="redigerRolleSkjema!.value.startdato" [formControl]="redigerRolleSkjema!.controls.sluttdato" required class="e2e-sluttdato" data-testid="rolle-sluttdato-felt" #sluttdatofelt>
            <mat-datepicker-toggle matPrefix [for]="sluttdatoVelger"/>
            <mat-datepicker #sluttdatoVelger/>
            @if(redigerRolleSkjema!.controls.sluttdato.hasError('matDatepickerParse')){
              <mat-error data-testid="matDatepickerParse">{{ redigerRolleSkjema!.controls.sluttdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
            }
            @if (redigerRolleSkjema!.controls.sluttdato.hasError('matDatepickerMin')) {
              <mat-error data-testid="matDatepickerMin">{{ 'Sluttdata kan ikke være tidligere enn startdato ({startdato})'|translate: {startdato: redigerRolleSkjema!.value.startdato!|plaindate} }}</mat-error>
            }
          </mat-form-field>
          @if(visStengTilgangOpsjon){
            <inline-melding type="info">
              <p>{{'Du er i ferd med å avslutte {medlem}s rolle.'|translate: {medlem: medlem().navn} }}</p>
              <p>
                {{'Vil du stenge {medlem}s tilgang til '|translate: {medlem: medlem().navn} }}
                <span class="uthevet">{{gruppe().tittel}} {{'i'}} {{gruppe().organisasjonsnavn}}</span>
              </p>
              <mat-slide-toggle [formControl]="redigerRolleSkjema!.controls.stengTilgang" class="e2e-stengTilgang" data-testid="steng-tilang">
                {{'Ja, steng tilgang'|translate}}
              </mat-slide-toggle>
            </inline-melding>
          }
        </form>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-button (click)="avbrytAktivDialog()">{{ "Avbryt"|translate }}</button>
        @if(redigerRolleSkjema!.value.stengTilgang){
            <button mat-raised-button color="primary" (click)="gaaTilStengTilgangTrinn()" [disabled]="redigerRolleSkjema!.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Neste"|translate }}</button>
        } @else {
          <button mat-raised-button color="primary" (click)="avsluttRolleperiode()" [disabled]="redigerRolleSkjema!.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Avslutt rolle"|translate }}</button>
        }
      </mat-dialog-actions>

    } @else {
      <!-- stengTilgang -->
      <mat-dialog-content class="skjema">
        <medlem-steng-tilgang-bekreftelse [medlem]="medlem()" [gruppe]="gruppe()"/>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-button (click)="avsluttRolleperiodeTrinn = 'avslutt'">{{ "Tilbake"|translate }}</button>
        <button mat-raised-button color="warn" (click)="avsluttRolleperiodeOgStengTilgang()" [disabled]="redigerRolleSkjema!.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Avslutt rolle og steng tilgang"|translate }}</button>
      </mat-dialog-actions>
    }
  </div>
</ng-template>

<!--Skjema for å sletting av eksisterende rolleperiode -->
<ng-template #slettRolleperiodeTemplate>
  <div class="slett-rolleperiode-dialog">
  <h2 mat-dialog-title>{{ "Angre registrering av rolle"|translate }}</h2>
  <mat-dialog-content class="skjema">
    <form>
      <p>
        {{'Er du sikker på at du vil slette permanent'|translate}}
        <span class="uthevet">{{redigerRolleSkjema!.value.rolleperiode!.tittel}}</span>
        {{'fra'|translate}} {{medlem().navn}}
      </p>
      <p class="meldingkontainer">
        <inline-melding type="feil">{{'Merk at slettingen ikke kan angres.'}}</inline-melding>
      </p>
      <tips>{{'Dersom medlemmet har byttet rolle kan du etterpå legge til ny'}}</tips>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button (click)="avbrytAktivDialog()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="warn" (click)="slettAktivRolleperiode()" [disabled]="redigerRolleSkjema!.invalid" cdkFocusInitial class="e2e-opprett-møte">{{ "Slett rollen permanent"|translate }}</button>
  </mat-dialog-actions>
  </div>
</ng-template>
